import { render, staticRenderFns } from "./C-3-1a-8__ProductInfoEdit_recommend.vue?vue&type=template&id=55331921&"
import script from "./C-3-1a-8__ProductInfoEdit_recommend.vue?vue&type=script&lang=js&"
export * from "./C-3-1a-8__ProductInfoEdit_recommend.vue?vue&type=script&lang=js&"
import style0 from "./C-3-1a-8__ProductInfoEdit_recommend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VIcon})
